export const SCANNER_FILTERS = Object.freeze(["original", "grayscale", "black-white"]);

export function nextScannerFilter(value) {
  const index = SCANNER_FILTERS.indexOf(value);
  return SCANNER_FILTERS[(index + 1) % SCANNER_FILTERS.length];
}

export function scannerFilterCss(value) {
  if (value === "grayscale") return "grayscale(1)";
  if (value === "black-white") return "grayscale(1) contrast(1.8)";
  return "none";
}

export function scannerCropFromInsets({ top = 0, right = 0, bottom = 0, left = 0 }) {
  const values = [top, right, bottom, left].map(value => Math.min(90, Math.max(0, Number(value) || 0)) / 100);
  const horizontalScale = values[1] + values[3] > .95 ? .95 / (values[1] + values[3]) : 1;
  const verticalScale = values[0] + values[2] > .95 ? .95 / (values[0] + values[2]) : 1;
  const x = values[3] * horizontalScale; const y = values[0] * verticalScale;
  return { x, y, width: 1 - x - values[1] * horizontalScale, height: 1 - y - values[2] * verticalScale };
}

export function scannerCropInsets(crop) {
  const value = crop || { x: 0, y: 0, width: 1, height: 1 };
  return { top: Math.round(value.y * 100), right: Math.round((1 - value.x - value.width) * 100), bottom: Math.round((1 - value.y - value.height) * 100), left: Math.round(value.x * 100) };
}
